import { createStore } from "easy-peasy";
import { storeModel } from "./storeModel";

export const store = createStore(storeModel);
